import React, { CSSProperties, FunctionComponent } from 'react';

export const Image: FunctionComponent<{
  alt?: string;
  src: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}> = ({ alt, src, width, height, className, style }) => {
  return (
    <img
      alt={alt}
      className={className}
      src={src}
      width={width}
      height={height}
      style={{
        maxWidth: '100%',
        height: 'auto',
        ...style,
      }}
    />
  );
};
